import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const NrcDecoderGuidePage = () => <DataDrivenGuidePage slug="guide-nrc-decoder" />;

export default NrcDecoderGuidePage;
